import { render, staticRenderFns } from "./ModalConfirmation.vue?vue&type=template&id=856c9c7c&scoped=true&"
import script from "./ModalConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmation.vue?vue&type=style&index=0&id=856c9c7c&prod&lang=css&"
import style1 from "./ModalConfirmation.vue?vue&type=style&index=1&id=856c9c7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856c9c7c",
  null
  
)

export default component.exports